export default __webpack_public_path__ + "static/media/industry6.5a1b7316.png";